export default __webpack_public_path__ + "static/char-s-09-en-3ccccadb94a11d56777fc83c8619f34e.webp";